export { default } from 'flows/core/pages/forgot-password';
